import React from "react";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { Link, useLocation, useNavigate, Outlet } from 'react-router-dom';
import { useAuth } from "../../../../context/AuthProvider";
import { ADMIN_USERS, SUPER_ADMIN } from '../../../../constant/index';
import useIsSmallScreen from '../../../../hooks/useIsSmallScreen';

const Content = () => {
  const { userEmail } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const isSmallScreen = useIsSmallScreen();
  const path = location.pathname.substring(1) || 'marketDashboard';
  const [value, setValue] = React.useState(path);

  const handleChange = (event, newValue) => {
    if (newValue === 'advancedCharting') {
      if (isSmallScreen) {
        navigate('/advancedCharting');
      }
      return;
    }
    setValue(newValue);
    navigate(newValue);
  };

  React.useEffect(() => {
    if (!['marketDashboard', 'patternRecognition', 'advancedCharting','futuresTrades', 'swingTrades'].includes(path)) {
      navigate('/marketDashboard');  // Default to dashboard if route is invalid
    }
    setValue(path);
  }, [path]);

  return (
    <div className="container py-5">
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }} className="tools-tabs-shell">
          <Tabs
            value={value}
            onChange={handleChange}
            variant={isSmallScreen ? 'scrollable' : 'standard'}
            scrollButtons={isSmallScreen ? 'auto' : false}
            allowScrollButtonsMobile
            className="tools-tabs"
          >
            <Tab className="tools-tab" label="Market Dashboard" value="marketDashboard" to="/marketDashboard" component={Link} />
            <Tab className="tools-tab" label="Pattern Recognition" value="patternRecognition" to="/patternRecognition" component={Link} />
            {
              SUPER_ADMIN.includes(userEmail) && (
                <Tab
                  className="tools-tab"
                  label="Advanced Charting"
                  value="advancedCharting"
                  {...(isSmallScreen
                    ? { to: '/advancedCharting', component: Link }
                    : {
                        onClick: (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          window.open('/advancedCharting', '_blank', 'noopener,noreferrer');
                        },
                      })}
                />
              )
            }
            {
              ADMIN_USERS.includes(userEmail) && (
                <>
                  <Tab className="tools-tab" label="Futures Trades" value="futuresTrades" to="/futuresTrades" component={Link} />
                  <Tab className="tools-tab" label="Swing Trades" value="swingTrades" to="/swingTrades" component={Link} />
                  {/* <span className="new-badge">NEW</span> */}
                </>
              )
            }
          </Tabs>
        </Box>
        <Box sx={{ padding: 2 }}>
          <Outlet />
        </Box>
      </Box>
    </div>
  );
}

export default Content;
